module.exports = __webpack_public_path__ + "img/dg.e6e9ac1a.svg";